import controller from './form-builder-node-components.controller';
import template from './form-builder-node-components.html';

export default {
	controller,
	bindings: {
		components: '<?',
	},
	template,
};
